import React, { useState } from 'react';
// import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import BulkThermostats from './thermostats/bulk-thermostats';
// import BulkSetpointLimits from './setpoint-limits/bulk-setpoint-limits';

import './ui/bulk-config.css';
import { useProperties } from '../../system/EntityManager';
import Box from '@mui/material/Box';

// Top level container for bulk config
export default function BulkConfig() {
  const [tab, setTab] = useState(0);

  const { properties, error, loading } = useProperties();

  return (
    <Box className="bulk-config-container">
      <Box className="bulk-config-header">
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          textColor="secondary"
          indicatorColor="secondary"
          centered
        >
          <Tab value={0} label="Thermostats" />
          {/* Hiding setpoint limits tab until feature is implemented
          /* <Tab value={1} label="Setpoint Limits" /> */}
        </Tabs>
      </Box>
      <Stack className="bulk-config-content">
        {loading && (
          <>
            <Typography sx={{ fontSize: '1.5em', margin: 1 }}>
              Loading...
            </Typography>
            <Typography sx={{ fontSize: '1.5em', margin: 1 }}>
              Loading...
            </Typography>
            <Typography sx={{ fontSize: '1.5em', margin: 1 }}>
              Loading...
            </Typography>
          </>
        )}
        {error && (
          <Typography color="danger">
            Error loading bulk config data.
          </Typography>
        )}
        {properties && (
          <>
            {tab === 0 ? (
              <BulkThermostats />
            ) : (
              // TODO: Feature: Implement bulk setpoint limits or remove this
              //  and the commented import above.
              // <BulkSetpointLimits properties={properties} />
              <div>Not yet implemented</div>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
}
